<template>
  <n-button
    v-show="hasBack"
    @click="goBack"
    quaternary
    size="small"
    class="back-button"
  >
    <template #icon>
      <n-icon :component="ArrowBackOutline" />
    </template>
    戻る
  </n-button>
</template>

<script setup>
import { NButton, NIcon } from 'naive-ui'
import { ArrowBackOutline } from '@vicons/ionicons5'
import { useRouter } from 'vue-router'

const router = useRouter()

const hasBack = () => {
  return router.currentRoute.value.meta.hasBack
}

const goBack = () => {
  router.back()
}
</script>

<style scoped>
.back-button {
  top: 10px;
  font-size: 14px;
  color: #666;
}
</style>
